"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.10
//   protoc               v6.33.5
// source: protos/openadr-svc.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenAdrServiceClientImpl = exports.OpenAdrServiceServiceName = exports.OadrReportDescription = exports.OadrReport = exports.OadrRegisterReport = exports.ReportSpecifierPayload = exports.ReportRequest = exports.OadrCreateReport = exports.Event = exports.OadrDistributeEvent = exports.OadrResponse = exports.PollResponse = exports.PollRequest = exports.RegisterVtnResponse = exports.RegisterVtnRequest = exports.eventStatusToJSON = exports.eventStatusFromJSON = exports.EventStatus = exports.protobufPackage = void 0;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
const timestamp_1 = require("../google/protobuf/timestamp");
exports.protobufPackage = "powernode";
var EventStatus;
(function (EventStatus) {
    EventStatus[EventStatus["NONE"] = 0] = "NONE";
    EventStatus[EventStatus["FAR"] = 1] = "FAR";
    EventStatus[EventStatus["NEAR"] = 2] = "NEAR";
    EventStatus[EventStatus["ACTIVE"] = 3] = "ACTIVE";
    EventStatus[EventStatus["COMPLETED"] = 4] = "COMPLETED";
    EventStatus[EventStatus["CANCELLED"] = 5] = "CANCELLED";
    EventStatus[EventStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(EventStatus = exports.EventStatus || (exports.EventStatus = {}));
function eventStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "NONE":
            return EventStatus.NONE;
        case 1:
        case "FAR":
            return EventStatus.FAR;
        case 2:
        case "NEAR":
            return EventStatus.NEAR;
        case 3:
        case "ACTIVE":
            return EventStatus.ACTIVE;
        case 4:
        case "COMPLETED":
            return EventStatus.COMPLETED;
        case 5:
        case "CANCELLED":
            return EventStatus.CANCELLED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return EventStatus.UNRECOGNIZED;
    }
}
exports.eventStatusFromJSON = eventStatusFromJSON;
function eventStatusToJSON(object) {
    switch (object) {
        case EventStatus.NONE:
            return "NONE";
        case EventStatus.FAR:
            return "FAR";
        case EventStatus.NEAR:
            return "NEAR";
        case EventStatus.ACTIVE:
            return "ACTIVE";
        case EventStatus.COMPLETED:
            return "COMPLETED";
        case EventStatus.CANCELLED:
            return "CANCELLED";
        case EventStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.eventStatusToJSON = eventStatusToJSON;
function createBaseRegisterVtnRequest() {
    return {
        vtnAddress: "",
        reportOnly: false,
        requestId: "",
        venId: "",
        registrationId: "",
        isReRegister: false,
    };
}
exports.RegisterVtnRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.vtnAddress !== "") {
            writer.uint32(10).string(message.vtnAddress);
        }
        if (message.reportOnly !== false) {
            writer.uint32(16).bool(message.reportOnly);
        }
        if (message.requestId !== "") {
            writer.uint32(26).string(message.requestId);
        }
        if (message.venId !== "") {
            writer.uint32(34).string(message.venId);
        }
        if (message.registrationId !== "") {
            writer.uint32(42).string(message.registrationId);
        }
        if (message.isReRegister !== false) {
            writer.uint32(48).bool(message.isReRegister);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRegisterVtnRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.vtnAddress = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.reportOnly = reader.bool();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.requestId = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.venId = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.registrationId = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.isReRegister = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            vtnAddress: isSet(object.vtnAddress)
                ? globalThis.String(object.vtnAddress)
                : "",
            reportOnly: isSet(object.reportOnly)
                ? globalThis.Boolean(object.reportOnly)
                : false,
            requestId: isSet(object.requestId)
                ? globalThis.String(object.requestId)
                : "",
            venId: isSet(object.venId) ? globalThis.String(object.venId) : "",
            registrationId: isSet(object.registrationId)
                ? globalThis.String(object.registrationId)
                : "",
            isReRegister: isSet(object.isReRegister)
                ? globalThis.Boolean(object.isReRegister)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.vtnAddress !== "") {
            obj.vtnAddress = message.vtnAddress;
        }
        if (message.reportOnly !== false) {
            obj.reportOnly = message.reportOnly;
        }
        if (message.requestId !== "") {
            obj.requestId = message.requestId;
        }
        if (message.venId !== "") {
            obj.venId = message.venId;
        }
        if (message.registrationId !== "") {
            obj.registrationId = message.registrationId;
        }
        if (message.isReRegister !== false) {
            obj.isReRegister = message.isReRegister;
        }
        return obj;
    },
    create(base) {
        return exports.RegisterVtnRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRegisterVtnRequest();
        message.vtnAddress = object.vtnAddress ?? "";
        message.reportOnly = object.reportOnly ?? false;
        message.requestId = object.requestId ?? "";
        message.venId = object.venId ?? "";
        message.registrationId = object.registrationId ?? "";
        message.isReRegister = object.isReRegister ?? false;
        return message;
    },
};
function createBaseRegisterVtnResponse() {
    return {
        registrationId: "",
        vtnId: "",
        venId: "",
        pollFrequency: 0,
        oadrProfiles: "",
        oadrServiceSpecificInfo: "",
        oadrExtensions: "",
    };
}
exports.RegisterVtnResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.registrationId !== "") {
            writer.uint32(10).string(message.registrationId);
        }
        if (message.vtnId !== "") {
            writer.uint32(18).string(message.vtnId);
        }
        if (message.venId !== "") {
            writer.uint32(26).string(message.venId);
        }
        if (message.pollFrequency !== 0) {
            writer.uint32(32).uint32(message.pollFrequency);
        }
        if (message.oadrProfiles !== "") {
            writer.uint32(42).string(message.oadrProfiles);
        }
        if (message.oadrServiceSpecificInfo !== "") {
            writer.uint32(50).string(message.oadrServiceSpecificInfo);
        }
        if (message.oadrExtensions !== "") {
            writer.uint32(58).string(message.oadrExtensions);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRegisterVtnResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.registrationId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.vtnId = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.venId = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.pollFrequency = reader.uint32();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.oadrProfiles = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.oadrServiceSpecificInfo = reader.string();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.oadrExtensions = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            registrationId: isSet(object.registrationId)
                ? globalThis.String(object.registrationId)
                : "",
            vtnId: isSet(object.vtnId) ? globalThis.String(object.vtnId) : "",
            venId: isSet(object.venId) ? globalThis.String(object.venId) : "",
            pollFrequency: isSet(object.pollFrequency)
                ? globalThis.Number(object.pollFrequency)
                : 0,
            oadrProfiles: isSet(object.oadrProfiles)
                ? globalThis.String(object.oadrProfiles)
                : "",
            oadrServiceSpecificInfo: isSet(object.oadrServiceSpecificInfo)
                ? globalThis.String(object.oadrServiceSpecificInfo)
                : "",
            oadrExtensions: isSet(object.oadrExtensions)
                ? globalThis.String(object.oadrExtensions)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.registrationId !== "") {
            obj.registrationId = message.registrationId;
        }
        if (message.vtnId !== "") {
            obj.vtnId = message.vtnId;
        }
        if (message.venId !== "") {
            obj.venId = message.venId;
        }
        if (message.pollFrequency !== 0) {
            obj.pollFrequency = Math.round(message.pollFrequency);
        }
        if (message.oadrProfiles !== "") {
            obj.oadrProfiles = message.oadrProfiles;
        }
        if (message.oadrServiceSpecificInfo !== "") {
            obj.oadrServiceSpecificInfo = message.oadrServiceSpecificInfo;
        }
        if (message.oadrExtensions !== "") {
            obj.oadrExtensions = message.oadrExtensions;
        }
        return obj;
    },
    create(base) {
        return exports.RegisterVtnResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRegisterVtnResponse();
        message.registrationId = object.registrationId ?? "";
        message.vtnId = object.vtnId ?? "";
        message.venId = object.venId ?? "";
        message.pollFrequency = object.pollFrequency ?? 0;
        message.oadrProfiles = object.oadrProfiles ?? "";
        message.oadrServiceSpecificInfo = object.oadrServiceSpecificInfo ?? "";
        message.oadrExtensions = object.oadrExtensions ?? "";
        return message;
    },
};
function createBasePollRequest() {
    return { venId: "", vtnAddress: "" };
}
exports.PollRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.venId !== "") {
            writer.uint32(10).string(message.venId);
        }
        if (message.vtnAddress !== "") {
            writer.uint32(18).string(message.vtnAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePollRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.venId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.vtnAddress = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            venId: isSet(object.venId) ? globalThis.String(object.venId) : "",
            vtnAddress: isSet(object.vtnAddress)
                ? globalThis.String(object.vtnAddress)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.venId !== "") {
            obj.venId = message.venId;
        }
        if (message.vtnAddress !== "") {
            obj.vtnAddress = message.vtnAddress;
        }
        return obj;
    },
    create(base) {
        return exports.PollRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePollRequest();
        message.venId = object.venId ?? "";
        message.vtnAddress = object.vtnAddress ?? "";
        return message;
    },
};
function createBasePollResponse() {
    return {
        oadrResponse: undefined,
        oadrDistributeEvent: undefined,
        oadrCreateReport: undefined,
    };
}
exports.PollResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.oadrResponse !== undefined) {
            exports.OadrResponse.encode(message.oadrResponse, writer.uint32(10).fork()).join();
        }
        if (message.oadrDistributeEvent !== undefined) {
            exports.OadrDistributeEvent.encode(message.oadrDistributeEvent, writer.uint32(18).fork()).join();
        }
        if (message.oadrCreateReport !== undefined) {
            exports.OadrCreateReport.encode(message.oadrCreateReport, writer.uint32(26).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePollResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.oadrResponse = exports.OadrResponse.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.oadrDistributeEvent = exports.OadrDistributeEvent.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.oadrCreateReport = exports.OadrCreateReport.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            oadrResponse: isSet(object.oadrResponse)
                ? exports.OadrResponse.fromJSON(object.oadrResponse)
                : undefined,
            oadrDistributeEvent: isSet(object.oadrDistributeEvent)
                ? exports.OadrDistributeEvent.fromJSON(object.oadrDistributeEvent)
                : undefined,
            oadrCreateReport: isSet(object.oadrCreateReport)
                ? exports.OadrCreateReport.fromJSON(object.oadrCreateReport)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.oadrResponse !== undefined) {
            obj.oadrResponse = exports.OadrResponse.toJSON(message.oadrResponse);
        }
        if (message.oadrDistributeEvent !== undefined) {
            obj.oadrDistributeEvent = exports.OadrDistributeEvent.toJSON(message.oadrDistributeEvent);
        }
        if (message.oadrCreateReport !== undefined) {
            obj.oadrCreateReport = exports.OadrCreateReport.toJSON(message.oadrCreateReport);
        }
        return obj;
    },
    create(base) {
        return exports.PollResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePollResponse();
        message.oadrResponse =
            object.oadrResponse !== undefined && object.oadrResponse !== null
                ? exports.OadrResponse.fromPartial(object.oadrResponse)
                : undefined;
        message.oadrDistributeEvent =
            object.oadrDistributeEvent !== undefined &&
                object.oadrDistributeEvent !== null
                ? exports.OadrDistributeEvent.fromPartial(object.oadrDistributeEvent)
                : undefined;
        message.oadrCreateReport =
            object.oadrCreateReport !== undefined && object.oadrCreateReport !== null
                ? exports.OadrCreateReport.fromPartial(object.oadrCreateReport)
                : undefined;
        return message;
    },
};
function createBaseOadrResponse() {
    return {
        venId: "",
        responseCode: "",
        responseDescription: "",
        requestId: "",
    };
}
exports.OadrResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.venId !== "") {
            writer.uint32(10).string(message.venId);
        }
        if (message.responseCode !== "") {
            writer.uint32(18).string(message.responseCode);
        }
        if (message.responseDescription !== "") {
            writer.uint32(26).string(message.responseDescription);
        }
        if (message.requestId !== "") {
            writer.uint32(34).string(message.requestId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOadrResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.venId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.responseCode = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.responseDescription = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.requestId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            venId: isSet(object.venId) ? globalThis.String(object.venId) : "",
            responseCode: isSet(object.responseCode)
                ? globalThis.String(object.responseCode)
                : "",
            responseDescription: isSet(object.responseDescription)
                ? globalThis.String(object.responseDescription)
                : "",
            requestId: isSet(object.requestId)
                ? globalThis.String(object.requestId)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.venId !== "") {
            obj.venId = message.venId;
        }
        if (message.responseCode !== "") {
            obj.responseCode = message.responseCode;
        }
        if (message.responseDescription !== "") {
            obj.responseDescription = message.responseDescription;
        }
        if (message.requestId !== "") {
            obj.requestId = message.requestId;
        }
        return obj;
    },
    create(base) {
        return exports.OadrResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOadrResponse();
        message.venId = object.venId ?? "";
        message.responseCode = object.responseCode ?? "";
        message.responseDescription = object.responseDescription ?? "";
        message.requestId = object.requestId ?? "";
        return message;
    },
};
function createBaseOadrDistributeEvent() {
    return { venId: "", requestId: "", events: [] };
}
exports.OadrDistributeEvent = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.venId !== "") {
            writer.uint32(10).string(message.venId);
        }
        if (message.requestId !== "") {
            writer.uint32(18).string(message.requestId);
        }
        for (const v of message.events) {
            exports.Event.encode(v, writer.uint32(26).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOadrDistributeEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.venId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.requestId = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.events.push(exports.Event.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            venId: isSet(object.venId) ? globalThis.String(object.venId) : "",
            requestId: isSet(object.requestId)
                ? globalThis.String(object.requestId)
                : "",
            events: globalThis.Array.isArray(object?.events)
                ? object.events.map((e) => exports.Event.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.venId !== "") {
            obj.venId = message.venId;
        }
        if (message.requestId !== "") {
            obj.requestId = message.requestId;
        }
        if (message.events?.length) {
            obj.events = message.events.map((e) => exports.Event.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.OadrDistributeEvent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOadrDistributeEvent();
        message.venId = object.venId ?? "";
        message.requestId = object.requestId ?? "";
        message.events = object.events?.map((e) => exports.Event.fromPartial(e)) || [];
        return message;
    },
};
function createBaseEvent() {
    return {
        responseRequired: false,
        eventId: "",
        modificationNumber: 0,
        modificationDateTime: undefined,
        modificationReason: "",
        priority: 0,
        eventStatus: 0,
        testEvent: false,
        vtnComment: "",
    };
}
exports.Event = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.responseRequired !== false) {
            writer.uint32(8).bool(message.responseRequired);
        }
        if (message.eventId !== "") {
            writer.uint32(18).string(message.eventId);
        }
        if (message.modificationNumber !== 0) {
            writer.uint32(24).uint32(message.modificationNumber);
        }
        if (message.modificationDateTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.modificationDateTime), writer.uint32(34).fork()).join();
        }
        if (message.modificationReason !== "") {
            writer.uint32(42).string(message.modificationReason);
        }
        if (message.priority !== 0) {
            writer.uint32(48).int32(message.priority);
        }
        if (message.eventStatus !== 0) {
            writer.uint32(56).int32(message.eventStatus);
        }
        if (message.testEvent !== false) {
            writer.uint32(64).bool(message.testEvent);
        }
        if (message.vtnComment !== "") {
            writer.uint32(74).string(message.vtnComment);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.responseRequired = reader.bool();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.eventId = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.modificationNumber = reader.uint32();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.modificationDateTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.modificationReason = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.priority = reader.int32();
                    continue;
                }
                case 7: {
                    if (tag !== 56) {
                        break;
                    }
                    message.eventStatus = reader.int32();
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.testEvent = reader.bool();
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.vtnComment = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            responseRequired: isSet(object.responseRequired)
                ? globalThis.Boolean(object.responseRequired)
                : false,
            eventId: isSet(object.eventId) ? globalThis.String(object.eventId) : "",
            modificationNumber: isSet(object.modificationNumber)
                ? globalThis.Number(object.modificationNumber)
                : 0,
            modificationDateTime: isSet(object.modificationDateTime)
                ? fromJsonTimestamp(object.modificationDateTime)
                : undefined,
            modificationReason: isSet(object.modificationReason)
                ? globalThis.String(object.modificationReason)
                : "",
            priority: isSet(object.priority) ? globalThis.Number(object.priority) : 0,
            eventStatus: isSet(object.eventStatus)
                ? eventStatusFromJSON(object.eventStatus)
                : 0,
            testEvent: isSet(object.testEvent)
                ? globalThis.Boolean(object.testEvent)
                : false,
            vtnComment: isSet(object.vtnComment)
                ? globalThis.String(object.vtnComment)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.responseRequired !== false) {
            obj.responseRequired = message.responseRequired;
        }
        if (message.eventId !== "") {
            obj.eventId = message.eventId;
        }
        if (message.modificationNumber !== 0) {
            obj.modificationNumber = Math.round(message.modificationNumber);
        }
        if (message.modificationDateTime !== undefined) {
            obj.modificationDateTime = message.modificationDateTime.toISOString();
        }
        if (message.modificationReason !== "") {
            obj.modificationReason = message.modificationReason;
        }
        if (message.priority !== 0) {
            obj.priority = Math.round(message.priority);
        }
        if (message.eventStatus !== 0) {
            obj.eventStatus = eventStatusToJSON(message.eventStatus);
        }
        if (message.testEvent !== false) {
            obj.testEvent = message.testEvent;
        }
        if (message.vtnComment !== "") {
            obj.vtnComment = message.vtnComment;
        }
        return obj;
    },
    create(base) {
        return exports.Event.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEvent();
        message.responseRequired = object.responseRequired ?? false;
        message.eventId = object.eventId ?? "";
        message.modificationNumber = object.modificationNumber ?? 0;
        message.modificationDateTime = object.modificationDateTime ?? undefined;
        message.modificationReason = object.modificationReason ?? "";
        message.priority = object.priority ?? 0;
        message.eventStatus = object.eventStatus ?? 0;
        message.testEvent = object.testEvent ?? false;
        message.vtnComment = object.vtnComment ?? "";
        return message;
    },
};
function createBaseOadrCreateReport() {
    return { requestId: "", venId: "", reportRequests: [] };
}
exports.OadrCreateReport = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.requestId !== "") {
            writer.uint32(10).string(message.requestId);
        }
        if (message.venId !== "") {
            writer.uint32(18).string(message.venId);
        }
        for (const v of message.reportRequests) {
            exports.ReportRequest.encode(v, writer.uint32(26).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOadrCreateReport();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.requestId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.venId = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.reportRequests.push(exports.ReportRequest.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            requestId: isSet(object.requestId)
                ? globalThis.String(object.requestId)
                : "",
            venId: isSet(object.venId) ? globalThis.String(object.venId) : "",
            reportRequests: globalThis.Array.isArray(object?.reportRequests)
                ? object.reportRequests.map((e) => exports.ReportRequest.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.requestId !== "") {
            obj.requestId = message.requestId;
        }
        if (message.venId !== "") {
            obj.venId = message.venId;
        }
        if (message.reportRequests?.length) {
            obj.reportRequests = message.reportRequests.map((e) => exports.ReportRequest.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.OadrCreateReport.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOadrCreateReport();
        message.requestId = object.requestId ?? "";
        message.venId = object.venId ?? "";
        message.reportRequests =
            object.reportRequests?.map((e) => exports.ReportRequest.fromPartial(e)) || [];
        return message;
    },
};
function createBaseReportRequest() {
    return {
        reportRequestdId: "",
        reportSpecifierId: "",
        granularityS: 0,
        reportBackDurationS: 0,
        reportInterval: "",
        reportSpecifierPayloads: [],
    };
}
exports.ReportRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.reportRequestdId !== "") {
            writer.uint32(10).string(message.reportRequestdId);
        }
        if (message.reportSpecifierId !== "") {
            writer.uint32(18).string(message.reportSpecifierId);
        }
        if (message.granularityS !== 0) {
            writer.uint32(24).uint64(message.granularityS);
        }
        if (message.reportBackDurationS !== 0) {
            writer.uint32(32).uint64(message.reportBackDurationS);
        }
        if (message.reportInterval !== "") {
            writer.uint32(42).string(message.reportInterval);
        }
        for (const v of message.reportSpecifierPayloads) {
            exports.ReportSpecifierPayload.encode(v, writer.uint32(50).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReportRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.reportRequestdId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.reportSpecifierId = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.granularityS = longToNumber(reader.uint64());
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.reportBackDurationS = longToNumber(reader.uint64());
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.reportInterval = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.reportSpecifierPayloads.push(exports.ReportSpecifierPayload.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            reportRequestdId: isSet(object.reportRequestdId)
                ? globalThis.String(object.reportRequestdId)
                : "",
            reportSpecifierId: isSet(object.reportSpecifierId)
                ? globalThis.String(object.reportSpecifierId)
                : "",
            granularityS: isSet(object.granularityS)
                ? globalThis.Number(object.granularityS)
                : 0,
            reportBackDurationS: isSet(object.reportBackDurationS)
                ? globalThis.Number(object.reportBackDurationS)
                : 0,
            reportInterval: isSet(object.reportInterval)
                ? globalThis.String(object.reportInterval)
                : "",
            reportSpecifierPayloads: globalThis.Array.isArray(object?.reportSpecifierPayloads)
                ? object.reportSpecifierPayloads.map((e) => exports.ReportSpecifierPayload.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.reportRequestdId !== "") {
            obj.reportRequestdId = message.reportRequestdId;
        }
        if (message.reportSpecifierId !== "") {
            obj.reportSpecifierId = message.reportSpecifierId;
        }
        if (message.granularityS !== 0) {
            obj.granularityS = Math.round(message.granularityS);
        }
        if (message.reportBackDurationS !== 0) {
            obj.reportBackDurationS = Math.round(message.reportBackDurationS);
        }
        if (message.reportInterval !== "") {
            obj.reportInterval = message.reportInterval;
        }
        if (message.reportSpecifierPayloads?.length) {
            obj.reportSpecifierPayloads = message.reportSpecifierPayloads.map((e) => exports.ReportSpecifierPayload.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ReportRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReportRequest();
        message.reportRequestdId = object.reportRequestdId ?? "";
        message.reportSpecifierId = object.reportSpecifierId ?? "";
        message.granularityS = object.granularityS ?? 0;
        message.reportBackDurationS = object.reportBackDurationS ?? 0;
        message.reportInterval = object.reportInterval ?? "";
        message.reportSpecifierPayloads =
            object.reportSpecifierPayloads?.map((e) => exports.ReportSpecifierPayload.fromPartial(e)) || [];
        return message;
    },
};
function createBaseReportSpecifierPayload() {
    return { rId: "", readingType: "" };
}
exports.ReportSpecifierPayload = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.rId !== "") {
            writer.uint32(10).string(message.rId);
        }
        if (message.readingType !== "") {
            writer.uint32(18).string(message.readingType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReportSpecifierPayload();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.rId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.readingType = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            rId: isSet(object.rId) ? globalThis.String(object.rId) : "",
            readingType: isSet(object.readingType)
                ? globalThis.String(object.readingType)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rId !== "") {
            obj.rId = message.rId;
        }
        if (message.readingType !== "") {
            obj.readingType = message.readingType;
        }
        return obj;
    },
    create(base) {
        return exports.ReportSpecifierPayload.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReportSpecifierPayload();
        message.rId = object.rId ?? "";
        message.readingType = object.readingType ?? "";
        return message;
    },
};
function createBaseOadrRegisterReport() {
    return { requestId: "", venId: "", reports: [], reportRequestId: "" };
}
exports.OadrRegisterReport = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.requestId !== "") {
            writer.uint32(10).string(message.requestId);
        }
        if (message.venId !== "") {
            writer.uint32(18).string(message.venId);
        }
        for (const v of message.reports) {
            exports.OadrReport.encode(v, writer.uint32(26).fork()).join();
        }
        if (message.reportRequestId !== "") {
            writer.uint32(34).string(message.reportRequestId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOadrRegisterReport();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.requestId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.venId = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.reports.push(exports.OadrReport.decode(reader, reader.uint32()));
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.reportRequestId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            requestId: isSet(object.requestId)
                ? globalThis.String(object.requestId)
                : "",
            venId: isSet(object.venId) ? globalThis.String(object.venId) : "",
            reports: globalThis.Array.isArray(object?.reports)
                ? object.reports.map((e) => exports.OadrReport.fromJSON(e))
                : [],
            reportRequestId: isSet(object.reportRequestId)
                ? globalThis.String(object.reportRequestId)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.requestId !== "") {
            obj.requestId = message.requestId;
        }
        if (message.venId !== "") {
            obj.venId = message.venId;
        }
        if (message.reports?.length) {
            obj.reports = message.reports.map((e) => exports.OadrReport.toJSON(e));
        }
        if (message.reportRequestId !== "") {
            obj.reportRequestId = message.reportRequestId;
        }
        return obj;
    },
    create(base) {
        return exports.OadrRegisterReport.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOadrRegisterReport();
        message.requestId = object.requestId ?? "";
        message.venId = object.venId ?? "";
        message.reports =
            object.reports?.map((e) => exports.OadrReport.fromPartial(e)) || [];
        message.reportRequestId = object.reportRequestId ?? "";
        return message;
    },
};
function createBaseOadrReport() {
    return {
        reportId: "",
        reportRequestId: "",
        reportSpecifierId: "",
        reportName: "",
        createdDateTime: undefined,
        reportDescriptions: [],
    };
}
exports.OadrReport = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.reportId !== "") {
            writer.uint32(10).string(message.reportId);
        }
        if (message.reportRequestId !== "") {
            writer.uint32(18).string(message.reportRequestId);
        }
        if (message.reportSpecifierId !== "") {
            writer.uint32(26).string(message.reportSpecifierId);
        }
        if (message.reportName !== "") {
            writer.uint32(34).string(message.reportName);
        }
        if (message.createdDateTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.createdDateTime), writer.uint32(42).fork()).join();
        }
        for (const v of message.reportDescriptions) {
            exports.OadrReportDescription.encode(v, writer.uint32(50).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOadrReport();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.reportId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.reportRequestId = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.reportSpecifierId = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.reportName = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.createdDateTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.reportDescriptions.push(exports.OadrReportDescription.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            reportId: isSet(object.reportId)
                ? globalThis.String(object.reportId)
                : "",
            reportRequestId: isSet(object.reportRequestId)
                ? globalThis.String(object.reportRequestId)
                : "",
            reportSpecifierId: isSet(object.reportSpecifierId)
                ? globalThis.String(object.reportSpecifierId)
                : "",
            reportName: isSet(object.reportName)
                ? globalThis.String(object.reportName)
                : "",
            createdDateTime: isSet(object.createdDateTime)
                ? fromJsonTimestamp(object.createdDateTime)
                : undefined,
            reportDescriptions: globalThis.Array.isArray(object?.reportDescriptions)
                ? object.reportDescriptions.map((e) => exports.OadrReportDescription.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.reportId !== "") {
            obj.reportId = message.reportId;
        }
        if (message.reportRequestId !== "") {
            obj.reportRequestId = message.reportRequestId;
        }
        if (message.reportSpecifierId !== "") {
            obj.reportSpecifierId = message.reportSpecifierId;
        }
        if (message.reportName !== "") {
            obj.reportName = message.reportName;
        }
        if (message.createdDateTime !== undefined) {
            obj.createdDateTime = message.createdDateTime.toISOString();
        }
        if (message.reportDescriptions?.length) {
            obj.reportDescriptions = message.reportDescriptions.map((e) => exports.OadrReportDescription.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.OadrReport.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOadrReport();
        message.reportId = object.reportId ?? "";
        message.reportRequestId = object.reportRequestId ?? "";
        message.reportSpecifierId = object.reportSpecifierId ?? "";
        message.reportName = object.reportName ?? "";
        message.createdDateTime = object.createdDateTime ?? undefined;
        message.reportDescriptions =
            object.reportDescriptions?.map((e) => exports.OadrReportDescription.fromPartial(e)) || [];
        return message;
    },
};
function createBaseOadrReportDescription() {
    return {
        rId: "",
        subject: "",
        dataSource: "",
        readingType: "",
        marketContext: "",
        samplingRate: "",
    };
}
exports.OadrReportDescription = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.rId !== "") {
            writer.uint32(10).string(message.rId);
        }
        if (message.subject !== "") {
            writer.uint32(18).string(message.subject);
        }
        if (message.dataSource !== "") {
            writer.uint32(26).string(message.dataSource);
        }
        if (message.readingType !== "") {
            writer.uint32(34).string(message.readingType);
        }
        if (message.marketContext !== "") {
            writer.uint32(42).string(message.marketContext);
        }
        if (message.samplingRate !== "") {
            writer.uint32(50).string(message.samplingRate);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOadrReportDescription();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.rId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.subject = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.dataSource = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.readingType = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.marketContext = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.samplingRate = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            rId: isSet(object.rId) ? globalThis.String(object.rId) : "",
            subject: isSet(object.subject) ? globalThis.String(object.subject) : "",
            dataSource: isSet(object.dataSource)
                ? globalThis.String(object.dataSource)
                : "",
            readingType: isSet(object.readingType)
                ? globalThis.String(object.readingType)
                : "",
            marketContext: isSet(object.marketContext)
                ? globalThis.String(object.marketContext)
                : "",
            samplingRate: isSet(object.samplingRate)
                ? globalThis.String(object.samplingRate)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rId !== "") {
            obj.rId = message.rId;
        }
        if (message.subject !== "") {
            obj.subject = message.subject;
        }
        if (message.dataSource !== "") {
            obj.dataSource = message.dataSource;
        }
        if (message.readingType !== "") {
            obj.readingType = message.readingType;
        }
        if (message.marketContext !== "") {
            obj.marketContext = message.marketContext;
        }
        if (message.samplingRate !== "") {
            obj.samplingRate = message.samplingRate;
        }
        return obj;
    },
    create(base) {
        return exports.OadrReportDescription.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOadrReportDescription();
        message.rId = object.rId ?? "";
        message.subject = object.subject ?? "";
        message.dataSource = object.dataSource ?? "";
        message.readingType = object.readingType ?? "";
        message.marketContext = object.marketContext ?? "";
        message.samplingRate = object.samplingRate ?? "";
        return message;
    },
};
exports.OpenAdrServiceServiceName = "powernode.OpenAdrService";
class OpenAdrServiceClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || exports.OpenAdrServiceServiceName;
        this.rpc = rpc;
        this.Poll = this.Poll.bind(this);
        this.RegisterVtn = this.RegisterVtn.bind(this);
    }
    Poll(request) {
        const data = exports.PollRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Poll", data);
        return promise.then((data) => exports.PollResponse.decode(new wire_1.BinaryReader(data)));
    }
    RegisterVtn(request) {
        const data = exports.RegisterVtnRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "RegisterVtn", data);
        return promise.then((data) => exports.RegisterVtnResponse.decode(new wire_1.BinaryReader(data)));
    }
}
exports.OpenAdrServiceClientImpl = OpenAdrServiceClientImpl;
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new globalThis.Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function longToNumber(int64) {
    const num = globalThis.Number(int64.toString());
    if (num > globalThis.Number.MAX_SAFE_INTEGER) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (num < globalThis.Number.MIN_SAFE_INTEGER) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return num;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
